import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import SecondTypeButton from 'src/components/Items/button/SecondTypeButton';
import { SearchOrder } from '../SearchOrder';
import TabList from '../TabList';
import { useActions } from 'src/hooks/useActions';
import { IPanelLinks } from 'src/models/IPanelLinks';
import './styles.scss';

interface IProps {
  links: IPanelLinks[];
}

const VerticalTabs: FC<IProps> = ({ links }) => {
  const { logOut } = useActions();
  const navigate = useNavigate();
  const [orderNumber, setOrderNumber] = useState('');
  const toExit = () => logOut();

  const handleClick = () => {
    if (orderNumber !== '') {
      navigate(`/order/${orderNumber}`);
      setOrderNumber('');
    }
  };

  useEffect(() => {
    const listener = (event: { code: string; preventDefault: () => void }) => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        event.preventDefault();
        if (orderNumber !== '') handleClick();
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [orderNumber]);

  return (
    <Box className='tabs-wrapper'>
      <SearchOrder
        placeholder='Search Order#'
        value={orderNumber}
        onChange={e => setOrderNumber(e.target.value)}
        InputProps={{
          endAdornment: (
            <button onClick={handleClick} className='search-button'>
              <ArrowForwardIosIcon />
            </button>
          ),
          type: 'number'
        }}
      />
      <TabList links={links} />
      <Box className='exit-button-wrapper'>
        <SecondTypeButton
          className='exit-button'
          title='Exit'
          startIcon={<ExitToAppOutlinedIcon />}
          onClick={toExit}
          children=''
        />
      </Box>
    </Box>
  );
};
export default VerticalTabs;
